import { SUBSCRIPTION_MANAGE_DESTINATION, useSubscriptionInfo } from "@next-platform/client-common-core";
import { SubscriptionPlatform } from "@next-platform/packages-ts-types";

import { ROUTES } from "@/constants";

const MANAGE_LINK_BY_DESTINATION = {
  [SUBSCRIPTION_MANAGE_DESTINATION.OVERVIEW]: ROUTES.manageSubscription,
  [SUBSCRIPTION_MANAGE_DESTINATION.SUBSCRIBE]: ROUTES.subscribe,
  [SUBSCRIPTION_MANAGE_DESTINATION.PORTAL]: ROUTES.portal,
  [SUBSCRIPTION_MANAGE_DESTINATION.CHECKOUT]: "https://spicychat.ai/checkout",
  [SUBSCRIPTION_MANAGE_DESTINATION.SUBSCRIBE_STAR]: "https://subscribestar.adult/subscriptions",
} as const;

const EXTERNAL_MANAGE_DESTINATIONS = new Set<string>([SUBSCRIPTION_MANAGE_DESTINATION.CHECKOUT, SUBSCRIPTION_MANAGE_DESTINATION.SUBSCRIBE_STAR]);

export default function useManageSubscription() {
  const { manageDestination, platform, shouldShowManage } = useSubscriptionInfo();

  const isMobileManagedSubscription = platform === SubscriptionPlatform.REVENUE_CAT;
  const resolvedManageLinkHref = MANAGE_LINK_BY_DESTINATION[manageDestination as keyof typeof MANAGE_LINK_BY_DESTINATION];
  const manageLinkHref = isMobileManagedSubscription ? undefined : resolvedManageLinkHref;
  const isExternalManageLink = EXTERNAL_MANAGE_DESTINATIONS.has(manageDestination);

  return {
    manageLinkHref,
    isExternalManageLink,
    isMobileManagedSubscription,
    shouldShowManage,
  };
}
